import m from "../../../../geodata/es2015/region/usa/ilLow";
window.am4geodata_region_usa_ilLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/ilLow.js
// module id = null
// module chunks = 